import React, { useEffect, useState } from "react";
import Image from "next/image";
import styles from "./planingDonation.module.scss";
import triggerIcon from "../../../new-images/profile/trigger-icon.svg";
import { inject, observer } from "mobx-react";
import redirectTo from "../../../utils/redirectTo";
import moment from "moment";
import Button from "../ui/button/Button";
import Link from "next/link";

type TWidget = {
  accept_button: string;
  blood_class: null;
  decline_button: null;
  description: string;
  help_text: string;
  plan_date: null;
  plan_id: null;
  title: string;
  type: string;
  content: null | { id: number; type: string; address: string; city: string };
  content_id: null | number;
  blood_station_address: string;
  collective_donation?: any
};

const WARNING_TEXT = "Важно: если ваш центр крови принимает по записи, то нужно отдельно записаться на сайте центра крови или через Госуслуги. Планирование донации на сайте DonorSearch позволит нам за 3 дня до указанной даты напомнить о вашем намерении совершить донацию и подготовиться к ней.";

const PlaningDonation = (props) => {
  const { newWidgetStore, plannedStore } = props;
  const [widgetData, setWidgerData] = useState<TWidget>();
  const [loader, setLoader] = useState(true);
  const date = moment(widgetData?.plan_date).format("ddd, D MMMM Y");
  const loadWidget = () => {
    setLoader(true);
    newWidgetStore.loadWidget().then((data) => {
      setWidgerData(data);
      setLoader(false);
    });
  };
  useEffect(() => {
    loadWidget();
  }, []);

  const deleteDonation = () => {
    plannedStore
      .deletePlan(widgetData?.plan_id)
      .then(() => loadWidget())
      .catch((err) => console.log(err));
  };

  const hiddenDoonation = () => {
    plannedStore
      .savePlan({ id: widgetData?.plan_id, status: "widget_abort" })
      .then(() => loadWidget())
      .catch((err) => console.log(err));
  };

  const onClickAcceptBtn = () => {
    if (widgetData?.type === "ongoing_planning") {
      if (widgetData?.content?.type === "event") {
        redirectTo(`/events/${widgetData?.content?.id}`);
      } else if (widgetData?.content?.type === "address_need") {
        redirectTo(`/recipient/${widgetData?.content?.id}`);
      } else {
        redirectTo("/profile/change_plan/");
      }
    } else if (widgetData?.type === "new_donation") {
      redirectTo("/profile/planning/");
    } else if (widgetData?.type === "planned_to_donate") {
      redirectTo("/profile/add_donation/");
    }
  };

  const onClickDeclineBtn = () => {
    if (widgetData?.type === "planned_to_donate") {
      // Изменяю статус прошедшего мероприятия, чтоб оно больше не показывалось
      hiddenDoonation();
    } else if (widgetData?.type === "ongoing_planning") {
      // Отмена записи на мероприятие сразу делает отписку от записи на мероприятие
      deleteDonation();
    }
  };


    return (
      <div className={styles.PlaningBlock}>
        <div className={!loader ? `${!widgetData?.collective_donation ? styles.Content : styles.ContentCoop}` : styles.Show}>
          {
            !widgetData?.collective_donation ?
            <>
              <h5 className={styles.PlaningBlock__title}>{widgetData?.title}</h5>
              {widgetData?.plan_date && (
                <p className={styles.PlaningBlock__date}>{date}</p>
              )}
              {widgetData?.blood_class && (
                <span className={styles.PlaningBlock__blood}>
                  {widgetData.blood_class}
                </span>
              )}
              <p
                className={`${styles.PlaningBlock__subtitle} ${
                  (widgetData?.blood_station_address ||
                    widgetData?.content?.address) &&
                  styles.PlaningBlock__subtitleShort
                }`}
                title={widgetData?.description}
              >
                {widgetData?.description}
              </p>
              <p
                className={`${styles.PlaningBlock__subtitle} ${styles.PlaningBlock__subtitleShort} ${styles.PlaningBlock__subtitleAddress}`}
                title={
                  widgetData?.blood_station_address || widgetData?.content?.address
                }
              >
                {widgetData?.blood_station_address || widgetData?.content?.address}
              </p>
              <div className={styles.PlaningBlock__warning}>
                {
                  widgetData?.type !== "planned_to_donate" &&
                  <div className={styles.PlaningBlock__warningImg}>
                    <Image
                      src={triggerIcon}
                      width={35}
                      height={35}
                      alt="warning-icon"
                    />
                    <div className={styles.PlaningBlock__warningImgPopup}>
                      <span>
                        {WARNING_TEXT}
                      </span>
                    </div>
                  </div>
                }
                <div className={styles.PlaningBlock__warningText}>
                  <span>
                    {widgetData?.help_text}
                  </span>
                </div>
              </div>
              <div className={styles.PlaningBlock__btns}>
                {widgetData?.decline_button && (
                  <div className={styles.RemoveCardBtn} onClick={onClickDeclineBtn}>
                    {widgetData.decline_button}
                  </div>
                )}
                <Button
                  children={widgetData?.accept_button}
                  onClick={onClickAcceptBtn}
                />
              </div>
            </>
            :
            <>
              <h5 className={styles.PlaningBlock__titleCoop}>{widgetData.type === 'ongoing_planning' ? 'Вы записаны на совместную донацию' : 'Вы были на совместной донации?'}</h5>
              {widgetData?.plan_date && (
                <div className={styles.PlaningBlock_wrapperDate}>
                  <p className={styles.PlaningBlock__date}>{date}</p>
                  <p className={styles.PlaningBlock__date}>{widgetData?.collective_donation?.plan_date?.split("T")[1].slice(0, 5)}</p>
                </div>
              )}
              <div className={styles.PlaningBlock_coopInfoWrapper}>
                <p>Организатор: <b>{widgetData?.collective_donation?.creator_user_obj?.first_name} {widgetData?.collective_donation?.creator_user_obj?.last_name}</b></p>
                <p
                  className={`${styles.PlaningBlock__subtitle} ${styles.PlaningBlock__subtitleShort}`}
                  title={widgetData?.description}
                >
                  {widgetData?.description}
                </p>
                <p
                  className={`${styles.PlaningBlock__subtitle} ${styles.PlaningBlock__subtitleShort}`}
                  title={
                    widgetData?.blood_station_address || widgetData?.content?.address
                  }
                >
                  {widgetData?.blood_station_address || widgetData?.content?.address}
                </p>
              </div>
              {
                widgetData.type === 'ongoing_planning' &&
                <div className={styles.PlaningBlock_linkBlock}>
                  <Link href={`/co-donations/${widgetData?.collective_donation?.id}`}>Подробнее</Link>
                </div>
              }

              {
                widgetData.type === 'planned_to_donate' &&
                <div className={styles.PlaningBlock_linkBlock}>
                  <p>{props?.authStore?.user?.first_name}, совершили ли вы донацию?</p>
                  <div className={styles.PlaningBlock__btns}>
                    {widgetData?.decline_button && (
                      <div className={styles.RemoveCardBtn} onClick={onClickDeclineBtn}>
                        {widgetData.decline_button}
                      </div>
                    )}
                    <Button
                      children={widgetData?.accept_button}
                      onClick={onClickAcceptBtn}
                    />
                  </div>
                </div>
              }
            </>
          }
        </div>
      </div>
    );
};

export default inject(
  "newWidgetStore",
  "plannedStore",
  "authStore"
)(observer(PlaningDonation));
